/*
 * ST 2026-10-05 country-switch (Wrike 4578311805) — see snippets/st-country-switch.liquid.
 * Opens the country dialog from every [data-st-country-open] button (delegated, so buttons in
 * re-rendered PDP price blocks keep working). Switching itself is a plain form submit.
 * ST 2026-10-24 (Wrike 4591189550): "Land & Sprache" — the language field lists only the languages of the
 * selected country, read from the hreflang alternates of the page ("de-CH" = German for CH, "de" without
 * region = primary market). Flag and "available: …" hint follow the selected country.
 * ST 2026-10-27 (Wrike 4592449484): the flag kept the start country because only src changed, not srcset.
 */
(function () {
  var dialog = document.getElementById("StCountryDialog");
  if (!dialog || typeof dialog.showModal !== "function") return;

  // Rendered inside the sticky header section. On phones (body clips overflow-x) Chrome then sends taps on the
  // open dialog to <html> once the page is scrolled, so close button and countries do not react. Under <body> it works.
  if (dialog.parentElement !== document.body) document.body.appendChild(dialog);

  var form = dialog.querySelector("form");
  var countrySelect = dialog.querySelector("#StCountrySelect");
  var languageSelect = dialog.querySelector("#StLanguageSelect");
  var flag = dialog.querySelector("[data-st-country-flag]");
  var hint = dialog.querySelector("#StLanguageHint");
  var template = dialog.getAttribute("data-available-template") || "";
  var currentCountry = dialog.getAttribute("data-current-country");
  var currentLanguage = languageSelect ? languageSelect.value : "";
  var storageKey = "st_country_languages";

  // Languages of the current market as rendered (value, name). Liquid only knows these; names of other
  // markets' languages come from the browser (Intl.DisplayNames, in their own language: "Français").
  var allLanguages = languageSelect
    ? Array.prototype.map.call(languageSelect.options, function (option) {
        return { code: option.value, name: option.textContent.trim() };
      })
    : [];

  function languageName(code) {
    var known = allLanguages.filter(function (l) {
      return l.code.toLowerCase() === code;
    })[0];
    if (known) return known;
    var name = code;
    try {
      name = new Intl.DisplayNames([code], { type: "language" }).of(code);
    } catch (e) {}
    return { code: code, name: name.charAt(0).toUpperCase() + name.slice(1) };
  }

  function languagesByCountry() {
    var regional = {};
    var primary = [];
    var links = document.querySelectorAll('link[rel="alternate"][hreflang]');
    Array.prototype.forEach.call(links, function (link) {
      var parts = link.getAttribute("hreflang").split("-");
      if (parts[0] === "x") return; // x-default
      if (parts.length === 1) {
        primary.push(parts[0].toLowerCase());
        return;
      }
      var country = parts.pop().toUpperCase();
      (regional[country] = regional[country] || []).push(
        parts.join("-").toLowerCase(),
      );
    });
    var map = null;
    if (links.length) {
      map = {};
      Array.prototype.forEach.call(countrySelect.options, function (option) {
        map[option.value] = regional[option.value] || primary;
      });
      try {
        sessionStorage.setItem(storageKey, JSON.stringify(map));
      } catch (e) {}
    } else {
      try {
        map = JSON.parse(sessionStorage.getItem(storageKey));
      } catch (e) {}
    }
    map = map || {};
    // Liquid knows the current market's languages exactly.
    var current = dialog.getAttribute("data-current-languages");
    if (current) map[currentCountry] = current.toLowerCase().split(",");
    return map;
  }

  var countryLanguages =
    countrySelect && languageSelect ? languagesByCountry() : {};

  function languagesFor(country) {
    var codes = countryLanguages[country];
    if (!codes || !codes.length) return allLanguages;
    // the country's own language first, English after (as in the design: "Deutsch, English")
    return codes
      .filter(function (code, i) {
        return codes.indexOf(code) === i;
      })
      .sort(function (a, b) {
        return (a.indexOf("en") === 0) - (b.indexOf("en") === 0);
      })
      .map(languageName);
  }

  function update(preferred) {
    var option = countrySelect.options[countrySelect.selectedIndex];
    if (!option) return;
    if (flag && option.getAttribute("data-flag")) {
      // image_tag also renders srcset (start country); the browser prefers it over src, so drop it (Wrike 4592449484).
      flag.removeAttribute("srcset");
      flag.removeAttribute("sizes");
      flag.src = option.getAttribute("data-flag");
    }

    var list = languagesFor(option.value);
    // Keep the chosen language if the country has it, else the country's own language (every market: local
    // language + English), else the first one.
    var pick =
      list.filter(function (l) {
        return l.code === preferred;
      })[0] ||
      list.filter(function (l) {
        return l.code.toLowerCase().indexOf("en") !== 0;
      })[0] ||
      list[0];

    languageSelect.innerHTML = "";
    list.forEach(function (language) {
      var item = new Option(
        language.name,
        language.code,
        false,
        language === pick,
      );
      item.lang = language.code;
      languageSelect.add(item);
    });

    if (hint && template) {
      hint.textContent = template
        .replace(
          "%c",
          option.getAttribute("data-name") || option.textContent.trim(),
        )
        .replace(
          "%l",
          list
            .map(function (l) {
              return l.name;
            })
            .join(", "),
        );
    }
  }

  if (countrySelect && languageSelect) {
    countrySelect.addEventListener("change", function () {
      update(languageSelect.value);
    });
    update(currentLanguage);

    // Nothing changed: just close instead of reloading the page.
    form.addEventListener("submit", function (event) {
      if (
        countrySelect.value === currentCountry &&
        languageSelect.value === currentLanguage
      ) {
        event.preventDefault();
        dialog.close();
      }
    });
  }

  var opener = null;

  document.addEventListener("click", function (event) {
    var trigger = event.target.closest("[data-st-country-open]");
    if (!trigger) return;
    event.preventDefault();
    opener = trigger;
    // always start from the current country and language
    if (countrySelect && languageSelect) {
      countrySelect.value = currentCountry;
      update(currentLanguage);
    }
    dialog.showModal();
    trigger.setAttribute("aria-expanded", "true");
    if (countrySelect) countrySelect.focus();
  });

  dialog.addEventListener("click", function (event) {
    // close button or a click on the backdrop (outside the dialog box)
    if (
      event.target.closest("[data-st-country-close]") ||
      event.target === dialog
    ) {
      dialog.close();
    }
  });

  // The cookie consent app (Pandectes) calls preventDefault on every Escape keydown, which blocks the native close.
  dialog.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;
    event.preventDefault();
    dialog.close();
  });

  dialog.addEventListener("close", function () {
    if (!opener) return;
    opener.setAttribute("aria-expanded", "false");
    if (document.contains(opener)) opener.focus();
    opener = null;
  });
})();
